import { InteractionType } from '@azure/msal-browser';
import { buildConfig } from './env-config';

export const environment = buildConfig({
  isProduction: false,
  isLocalDev: false,
  apiUrl: 'https://changeover-qa.unilever.com/coapi',
  tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  frontendApplicationId: '0eb6b67d-fa01-414f-b383-b235704d1e2c',
  backendApplicationId: '4e48a067-9ccc-4214-b225-00561575e5ad',
  interactionType: InteractionType.Popup,
});
